__turbopack_context__.v({
  "carousel": "carousel-module-sass-module__dXBTPG__carousel",
  "center": "carousel-module-sass-module__dXBTPG__center",
  "container": "carousel-module-sass-module__dXBTPG__container",
  "custom": "carousel-module-sass-module__dXBTPG__custom",
  "dot": "carousel-module-sass-module__dXBTPG__dot",
  "dots": "carousel-module-sass-module__dXBTPG__dots",
  "fade": "carousel-module-sass-module__dXBTPG__fade",
  "next": "carousel-module-sass-module__dXBTPG__next",
  "prev": "carousel-module-sass-module__dXBTPG__prev",
  "selectedDot": "carousel-module-sass-module__dXBTPG__selectedDot",
  "slide": "carousel-module-sass-module__dXBTPG__slide",
  "top": "carousel-module-sass-module__dXBTPG__top",
});
